import React, {useContext} from "react";
import { ReactComponent as SearchIcon } from "../../assets/icons/search-black.svg";
import { ReactComponent as SuggestionArrowIcon } from "../../assets/icons/suggestion-arrow.svg";
import classes from './AutocompleteItem.module.scss';
import { SanitizeHTML } from "../SanitizeHtml/SanitizeHtml";
import { Link } from 'react-router-dom';
import { RefinedSearchContext } from "../../context";
import { useInstantSearch } from "react-instantsearch";
interface AutocompleteItemProps {
  objectID: string;
  isSuggestion?: boolean;
  [x: string]: any;
}

export const AutocompleteItem: React.FC<AutocompleteItemProps> = ({
  isJob,
  objectID,
  isSuggestion,
  group,
  query = "",
  setAutocompleteIsOpen,
  groupLabel,
  title = "",
  ...props
}) => {
  const { setIsFormSubmitted } = useContext(RefinedSearchContext);
  const { setIndexUiState } = useInstantSearch();

  const handleGroupClick = ({ group }: { query: string; group: string }) => {
    setIndexUiState(prevIndexUiState => ({
      ...prevIndexUiState,
      refinementList: {
        ...prevIndexUiState.refinementList,
        group: [group]
      }
    }));
  };

  if (isJob) {
    return (
      <div className={classes.autocompleteItemProductWrapper}>
        <Link
          className={classes.autocompleteItemProductLink}
          to={{
            pathname: window.location.pathname,
            search: `?jobId=${objectID}`,
            state: window.location.search,
          }}
        >
          <div className={classes.autocompleteItemProductTitleWrapper}>
            <div
              {...props}
              className={`${classes.autocompleteItem} ${classes.product}`}
            >
              <SanitizeHTML html={title} />
            </div>
            <div className={classes.autocompleteItemSearchIcon}>
              <SearchIcon />
            </div>
          </div>
        </Link>
        <div
          className={classes.autocompleteItemProductLink}
          onClick={() => {
            if (handleGroupClick) {
              handleGroupClick({ group, query });
            }
            if (setIsFormSubmitted) {
              setIsFormSubmitted(true);
            }
            setAutocompleteIsOpen(false);
          }}
        >
          <div className={classes.autocompleteItemProductSubtitle}>
            <div className={classes.autocompleteItemProductArrow}>
              <SuggestionArrowIcon />
            </div>
            <div>{groupLabel}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div {...props} className={classes.autocompleteItem}>
      <div className={classes.autocompleteItemSearchIcon}>
        <SearchIcon />
      </div>
      {query}
    </div>
  );
};